import classNames from 'classnames';
import React from 'react';
import styles from './Pie.module.scss';
function Pie({ value = 0, total = 0, white = true, color: colorProp, size = 's' }) {
    const color = colorProp || (white ? 'white' : '#333333');
    const percent = total > 0 ? Math.round((value / total) * 100) : 0;
    const circleClass = percent === 0 ? `${styles.circle} ${styles.hidden}` : styles.circle;
    return (React.createElement("div", { className: classNames(styles.wrapper, styles[size]) },
        React.createElement("div", { className: circleClass, style: {
                '--p': percent,
                '--c': color,
            } },
            React.createElement("div", { className: styles.border }),
            React.createElement("div", { className: styles.dot })),
        React.createElement("div", { className: styles.value },
            percent,
            "%")));
}
export default Pie;
